<template>
<div class="chapter">
<div class="inner_page">
<p class="normalb"><i>I am accustoming myself to the idea of regarding every sexual act as a process in which four persons are involved. We shall have a lot to discuss about that</i>.</p>
<p class="right"><span>S. FREUD: <i>Letters</i></span></p>
<p class="normalb sgc-1">There are two positions available to us – either crime which renders us happy, or the noose, which prevents us from being unhappy. I ask whether there can be any hesitation, lovely Thérèse, and where will your little mind find an argument able to combat that one?</p>
<p class="right"><span>D. A. F. DE SADE: <i>Justine</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_series.vue?1c714f02